import React, { Fragment, useEffect } from 'react'
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Divider
} from '@mui/material'
import {
  Label as LabelIcon,
  Description as DescriptionIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon
} from '@mui/icons-material'
import { ProductExternalReference } from '../../../interfaces/Producto/ProductExternalReference'
import { getProductExternalReferenceById } from '../config/api'
import { useApi } from '../../../hooks/useApi'
import { Status } from '../../../hooks/useFetchState'
import { Loading } from '../../../components/UI'

interface ViewProductExternalReferenceProps {
  productExternalReferenceId: number
  handleSnackbar: (message: string, success: boolean) => void
}

export const ViewProductExternalReference: React.FC<
  ViewProductExternalReferenceProps
> = ({ productExternalReferenceId, handleSnackbar }) => {
  const { state, callApi } = useApi<ProductExternalReference>()

  useEffect(() => {
    callApi(getProductExternalReferenceById(productExternalReferenceId)).catch(
      (error) => {
        handleSnackbar(error, false)
      }
    )
  }, [])

  if (state.status === Status.Loading) {
    return (
      <div>
        <Typography>
          <Loading />
        </Typography>
      </div>
    )
  }

  return (
    <Fragment>
      <List>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <LabelIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary='Nombre' secondary={state.data?.name} />
        </ListItem>

        <Divider variant='inset' component='li' />

        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <DescriptionIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary='Descripción'
            secondary={state.data?.description}
          />
        </ListItem>

        <Divider variant='inset' component='li' />

        <ListItem>
          <ListItemAvatar>
            <Avatar>
              {state.data?.isActive ? <CheckCircleIcon /> : <CancelIcon />}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary='Estado'
            secondary={state.data?.isActive ? 'Activo' : 'Inactivo'}
          />
        </ListItem>
      </List>
    </Fragment>
  )
}
